<template>
	<div>
		<el-card class="box">
			<el-form label-width="100" label-position="left" inline="" style="margin-top: -10px;">
				核销免单
				<el-form-item label="订单id">
					<el-input v-model="send.orderId" size="small" class="l"></el-input>
				</el-form-item>
				<el-form-item label="用户id">
					<el-input v-model="send.userId" size="small" class="l"></el-input>
				</el-form-item>
				<el-form-item label="券码">
					<el-input v-model="send.couponCode" size="small" width="300px"></el-input>
				</el-form-item>
				<el-form-item label="抖音券码">
					<el-input v-model="send.remark" size="small" class="l"></el-input>
				</el-form-item>
				<el-form-item label="抖音套餐">
					<el-select v-model="send.type" size="small" class="l">
						<el-option-group label="选择套餐" class="store">
							<el-option v-for="item in product" :key="item.id" :label="item.name" :value="item.name">
							</el-option>
						</el-option-group>
					</el-select>
				</el-form-item>
				<el-button @click="save()" type="primary" size="small" style="margin-top: 5px;">确定</el-button>
			</el-form>
		</el-card>
		<el-card class="box">
			<p style="margin-top: -5px;">
				查找订单
				<el-select v-model="query.type" style="width: 150px;margin-right: 20px;" size="small">
					<el-option v-for="item in keys" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-input type="text" style="width: 250px;margin-right: 20px;" size="small" v-model="query.text"
					@keydown.enter.native="getOrder()">
				</el-input>
				<el-button type="primary" size="small" @click="getOrder()">筛选</el-button>
			</p>
			<div>
				<el-table :data="order"
					:header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D' }"
					:cell-style="{'text-align': 'center'}">
					<el-table-column prop="id" label="id"></el-table-column>
					<el-table-column prop="userId" label="用户id"></el-table-column>
					<el-table-column prop="storeName" label="门店名"></el-table-column>
					<el-table-column prop="type" label="服务"></el-table-column>
					<el-table-column prop="goodsTotal" label="服务价格">
						<template slot-scope="{row}">
							{{(row.goodsTotal*1).toFixed(2)}}
						</template>
					</el-table-column>
					<el-table-column prop="userId" label="用户id"></el-table-column>
					<el-table-column prop="workerId" label="发型师id"></el-table-column>
					<el-table-column prop="workerName" label="发型师"></el-table-column>
					<el-table-column prop="status" label="状态">
						<template slot-scope="{row}">
							{{row.status | statuF}}
						</template>
					</el-table-column>
					<el-table-column label="类型">
						<template slot-scope="{row}">
							{{row.orderType | typeFormat}}
						</template>
					</el-table-column>
					<el-table-column prop="payTime" label="支付时间" width="150px">
						<template slot-scope="{row}">
							{{row.payTime==null?'/':row.payTime}}
						</template>
					</el-table-column>
					<el-table-column prop="addTime" label="添加时间" width="150px"></el-table-column>

				</el-table>
				<div style="text-align: center;">
					<el-pagination background @current-change="handleCurrentChange" @size-change="handleSizeChange"
						style="margin-top: 30px;" layout=" total, prev, pager, next, jumper" :current-page="query.page"
						:total="query.total">
					</el-pagination>
				</div>
			</div>
		</el-card>
		<el-card class="box">
			<p style="margin-top: -5px;">
				<el-form label-width="100" label-position="left" inline="">
					查找券码
					<el-select v-model="query.typeCoupon" style="width: 150px;margin-right: 20px;" size="small">
						<el-option v-for="item in keyss" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-input type="text" style="width: 250px;margin-right: 20px;" size="small" v-model="query.code"
						@keydown.enter.native="getCouponCode()">
					</el-input>
					<!-- <el-form-item label="用户id" style="margin-top: -5px;">
					<el-input type="text" style="width: 100px;margin-right: 20px;" size="small" v-model="query.code"
						@keydown.enter.native="getCouponCode()">
					</el-input>
				</el-form-item> -->
					<el-button type="primary" size="small" @click="getCouponCode()">筛选</el-button>
				</el-form>
			</p>
			<el-table :data="codeList"
				:header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D' }"
				:cell-style="{'text-align': 'center'}">
				<el-table-column prop="code" label="券码"></el-table-column>
				<el-table-column prop="outsideCode" label="外部券码">
					<template slot-scope="{row}">
						{{row.outsideCode==null?'/':row.outsideCode}}
					</template>
				</el-table-column>
				<el-table-column prop="couponTitle" label="券名"></el-table-column>
				<el-table-column prop="userId" label="用户id">
					<template slot-scope="{row}">
						<el-input v-if="row.edit==true" v-model="row.userId" style="width: 80px;"></el-input>
						<div v-else>
							{{row.userId}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="状态">
					<template slot-scope="{row}">
						<div v-if="row.edit==true">
							<el-select v-model="row.status" size="small" style="width: 100px;">
								<el-option v-for="item in couponStatus" :key="item.key" :value="item.key"
									:label="item.label"></el-option>
							</el-select>
						</div>
						<div v-else>
							<div v-if="row.status==1 && new Date(row.expiredTime)< new Date()">
								<el-tag type="info">已过期</el-tag>
							</div>
							<div v-else>
								<el-tag v-if="row.status==0" type="info">未领取</el-tag>
								<el-tag v-if="row.status==1">已领取</el-tag>
								<el-tag v-if="row.status==2" type="success">已使用</el-tag>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="orderId" label="所属订单id">
					<template slot-scope="{row}">
						{{row.orderId==null?'/':row.orderId}}
					</template>
				</el-table-column>
				<el-table-column prop="expiredTime" label="到期时间"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="{row}">
						<el-button v-if="row.edit==false" type="text" @click="editMeth(row,1)">编辑</el-button>
						<div v-else>
							<el-button type="text" @click="saveRow(row)" style="color: red;">保存</el-button>
							<el-button type="text" @click="editMeth(row,-1)">取消</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</el-card>
		<el-card class="box">
			<el-form label-width="100" label-position="left" inline="" style="margin-top: -10px;">
				绑定会员
				<el-form-item label="剪发id">
					<el-input v-model="link.orderId" size="small" class="l"></el-input>
				</el-form-item>
				<el-form-item label="套餐id">
					<el-input v-model="link.memberId" size="small" class="l"></el-input>
				</el-form-item>
				<el-form-item label="会员提成">
					<el-input v-model="link.amount" size="small" class="l"></el-input>
				</el-form-item>
				<el-form-item label="会员业绩">
					<el-input v-model="link.yeji" size="small" class="l"></el-input>
				</el-form-item>
				<el-button @click="links()" type="primary" size="small" style="margin-top: 5px;">绑定</el-button>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				send: {
					orderId: '',
					userId: '',
					couponCode: '',
					remark: '',
					type: ''
				},
				link: {
					orderId: '', //id
					memberId: '', //keyword
					amount: '', //
					yeji: '' //
				},
				product: [],
				order: [],
				codeList: [],
				query: {
					type: 0,
					typeCoupon: 3,
					text: '',
					code: '',
					size: 10,
					page: 1,
					total: 0,
				},
				keys: [{
					label: "订单号",
					value: 1,
				}, {
					label: "剪发订单ID",
					value: 0,
				}, {
					label: "用户ID",
					value: 3,
				}, {
					label: "商品名称",
					value: 2,
				}, {
					label: "手机号",
					value: 4,
				}],
				keyss: [{
					label: "用户ID",
					value: 3,
				}, {
					label: "手机号",
					value: 4,
				}],
				edit: false,
				couponStatus: [{
					key: 0,
					label: '未领取'
				}, {
					key: 1,
					label: '已领取'
				}, {
					key: 2,
					label: '已使用'
				}, ]
			}
		},
		filters: {
			typeFormat(val) {
				switch (val.toString()) {
					case "1":
						return "普通订单";
					case "3":
						return "次卡订单";
					case "10":
						return "染发次卡订单";
					case "5":
						return "膨胀券订单";
					case "6":
						return "会员订单";
					case "7":
						return "会员续费订单";
					case "9":
						return "美团订单";
					case "2":
						return "企业剪订单";
					case "11":
						return "权益订单";
					case "4":
						return "抖音审核订单";
					default:
						return "/";
				}
			},
			statuF(val) {
				switch (val.toString()) {
					case "0":
						return "排队中";
					case "1":
						return "服务中";
					case "2":
						return "待付款";
					case "3":
						return "已支付";
					case "5":
						return "已完成";
					case "-1":
						return "已取消";
					case "21":
						return "支付中";
					default:
						return "/";
				}
			}
		},
		mounted() {
			this.getProductGroup()
		},
		methods: {
			getOrder() {
				if (this.query.text != null && this.query.text != '') {
					this.$http.get("handle/orders" + this.requestData()).then(res => {
						this.order = res.body.data
						this.query.total = res.body.total
					})
				}
			},
			getProductGroup() {
				this.$http.get("dProductGroup/list").then(res => {
					this.product = res.body.data
				})
			},
			save() {
				if (this.send.orderId == null) {
					return this.$message.error("请填写订单id")
				}
				if (this.send.userId == null) {
					return this.$message.error("请填写用户id")
				}
				if (this.send.couponCode == null) {
					return this.$message.error("请填写券码")
				}
				var s = this.send
				var a = "?id=" + s.orderId + "&text=" + s.userId + "&content=" + s.couponCode
				var b = "?id=" + s.orderId
				if (s.remark) {
					b = b + "&remark=" + s.remark
					if (s.type) {
						b = b + "&type=" + s.type
					}
					this.$http.get("handle/shenhe" + b).then(res => {
						if (res.body.code == 200) {
							this.$message.success("审核订单添加成功")
						} else {
							this.$message.error(res.body.msg)
						}
					})
				}
				this.$http.get("handle/free" + a).then(res => {
					if (res.body.code == 200) {
						this.$message.success("免单核销成功")
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			links() {
				if (this.link.orderId == null) {
					return this.$message.error("请填写订单id")
				}
				if (this.link.memberId == null) {
					return this.$message.error("请填写套餐id")
				}
				if (this.link.amount == null) {
					return this.$message.error("请填写会员提成")
				}
				if (this.link.yeji == null) {
					return this.$message.error("请填写会员业绩")
				}
				var a = "?id=" + this.link.orderId + "&keyword=" + this.link.memberId
				var b = "?id=" + this.link.memberId + "&amount=" + this.link.amount + "&yeji=" + this.link.yeji
				this.$http.get("handle/bangding" + a).then(res => {
					if (res.body.code == 200) {
						this.$message.success("套餐绑定成功")
						this.$http.get("handle/memberCommission" + b).then(res => {
							if (res.body.code == 200) {
								this.$message.success("会员业绩添加成功")
							} else {
								this.$message.error(res.body.msg)
							}
						})
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			requestData() {
				let query = "?pageNum=" + this.query.page + "&pageSize=" + this.query.size;
				if (this.query.text) query += "&type=" + this.query.type + "&text=" + this.query.text;
				return query;
			},
			getCouponCode() {
				if (this.query.code != null) {
					this.$http.get("handle/couponCode?text=" + this.query.code + "&type=" + this.query.typeCoupon).then(
						res => {
							this.codeList = res.body.data
							this.codeList.forEach(c => {
								this.$set(c, "edit", false)
							})
						})
				} else {
					this.$message.error("请填写用户id")
				}
			},
			saveRow(row) {
				this.$delete(row, 'edit')
				var a = {
					id: row.id,
					code: row.code,
					couponId: row.couponId,
					status: row.status,
					userId: row.userId,
					nickName: row.nickName,
					outsideCode: row.outsideCode,
					expiredTime: row.expiredTime
				}
				this.$http.post("handle/saveCouponCode", JSON.stringify(a)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功")
						this.getCouponCode()
					} else {
						this.$message.error("保存失败")
					}
				})
			},
			editMeth(row, id) {
				if (id == -1) {
					row.edit = false //退出编辑
				} else if (id == 1) {
					row.edit = true //编辑状态
				}
			},
			handleCurrentChange(val) {
				this.query.page = val;
				this.getOrder()
			},
			handleSizeChange(val) {
				this.query.size = val;
				this.getOrder()
			},
		}
	}
</script>

<style>
	.l {
		width: 150px;
	}

	.box {
		margin-top: 15px;
	}
</style>